import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { createApi } from "@reduxjs/toolkit/query/react";
import { UserResponse } from "pages/Settings/types";
import { baseQueryWithReAuth } from "utils/baseQueryWithReAuth";

export const initialState: UserResponse = {
    data: {
        attributes: {
            id: "",
            email: "",
            username: null,
            first_name: "",
            last_name: "",
            gender: "",
            nationality: "",
            dob: "",
            qualification: "",
            work_status: "",
            user_type: "",
            hourly_charge: null,
            total_experience: null,
            created_at: "",
            updated_at: "",
            languages: [],
            user_location: {
                id: "",
                country_name: "",
                user_id: "",
                created_at: "",
                updated_at: "",
                city: "",
            },
            contact_detail: {
                id: "",
                code: "",
                mobile_number: "",
                is_whatsapp_different: false,
                whatsapp_number: "",
                whatsapp_code: "",
                user_id: "",
                created_at: "",
                updated_at: "",
            },
            physical_detail: {
                id: "",
                created_at: "",
                updated_at: "",
                weight: "",
                height: "",
                hips: "",
                waist: "",
                bust: "",
                eye_color: "",
                hair_color: "",
                hair_length: "",
                piercings: "",
                genres: null,
                ethnicity: "",
                tattoos: "",
                physical_detailable_type: "",
                physical_detailable_id: "",
                min_height: null,
                max_height: null,
                min_weight: null,
                max_weight: null,
            },
            social_links: [],
            agency: null,
            roles: [],
            active_plan: null,
        },
        id: "",
        type: "",
    },
};

export const modelSlice = createSlice({
    name: "model",
    initialState,
    reducers: {
        setModelProfile(
            state,
            { payload }: PayloadAction<UserResponse | undefined>
        ) {
            return { ...state, ...payload };
        },
    },
});

export const modelApiSlice = createApi({
    reducerPath: "modelApi",
    baseQuery: baseQueryWithReAuth,
    endpoints(builder) {
        return {};
    },
});

export const { setModelProfile } = modelSlice.actions;
export default modelSlice.reducer;
